<template>

  <div>
    <!-- Table Container Card -->
    <template>
      <div id="breadcrumb-alignment" class="mb-1">
        <div class="d-flex justify-content-start breadcrumb-wrapper">
          <b-breadcrumb
            :items="breadCrumb()"
          />
        </div>
      </div>
    </template>

    <b-card no-body>
    
      <b-card-body>
        <b-row>
          <b-col
            cols="12"
            md="4"
            class="mb-md-0 mb-2 mobile_tab_max_width_flex mobile_tab_margin_bottom_point_five">
            <!-- <label>Status</label> -->
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="sites"
              label="site_name"
              class="w-100"
              placeholder="Project Site"
              @input="siteChange"
              v-model="siteData"
              :clearable="false"
            >
              <template #selected-option="{ site_name }">
                <span v-if="site_name.length < 23">{{site_name}}</span>
                <span v-if="site_name.length >= 23">{{site_name.substring(0, 23) + '..'}}</span>
              </template>
            </v-select>
          </b-col>

          <b-col
            cols="12"
            md="4"
            class="mb-md-0 mb-2 mobile_tab_max_width_flex mobile_tab_margin_bottom_point_five">
            <!-- <label>Status</label> -->
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="frequencies"
              label="name"
              class="w-100"
              placeholder="Frequency"
              @input="filterTable"
              v-model="frequencyData"
              :clearable="true"
            />
          </b-col>

          <b-col
            cols="12"
            md="4"
            class="mb-md-0 mobile_tab_max_width_flex "
            >

            <!-- <label>Status</label> -->
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="groupArray"
              class="w-100"
              placeholder="Group"
              @input="filterTable"
              multiple
              v-model="group"
              :close-on-select=false
                            :clear-on-select=false
            />
          </b-col>
          
        </b-row>
      </b-card-body>
    </b-card>

    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">
        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="3"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0 mobile_tab_max_width_flex mobile_margin_bottom_1rem"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
              @input="filterTable"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="9"
            class="mobile_tab_max_width_flex all_btn_tab"
          >
            <div class="d-flex align-items-center justify-content-end mobile-view mobile_tab_display_block">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1 mobile-margin-bottom mobile-margin-input mobile_margin_bottom_1rem"
                placeholder="Search..."
                @input="filterTable"
              />

              <b-button
                v-if="checkPermission($route.name, 'Delete')"
                variant="danger"
                class="mr-1 mobile-margin-bottom"
                @click="changeMultipleStatus('deleted')"
              >
                <span class="text-nowrap">Delete</span>
              </b-button>

              <!-- <b-button
                v-if="checkPermission($route.name, 'Change Status')"
                variant="success"
                class="mr-1"
                @click="changeMultipleStatus('active')"
              >
                <span class="text-nowrap">Activate</span>
              </b-button>

              <b-button
                v-if="checkPermission($route.name, 'Change Status')"
                variant="primary"
                class="mr-1"
                @click="changeMultipleStatus('inactive')"
              >
                <span class="text-nowrap">Inactivate</span>
              </b-button> -->


              <b-button
                v-if="checkPermission($route.name, 'Add Schedule Task')"
                variant="warning"
                :to="{name:'add-periodic-task'}"
                class=" mobile-margin-bottom"
              >
                <span class="text-nowrap">Add Schedule Task</span>
              </b-button>

              


            </div>




          </b-col>
        </b-row>

      </div>
      <b-table sticky-header
        ref="refUserListTable"
        class="position-relative  midTable common_big_tbl"
        :items="dataList"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
        :class="items.length <= 10 ? 'remove_overflow' : 'add_overflow'"
      >

        <template #head(checkbox)="items">
          <b-form-checkbox class="custom-control-primary" v-model="selectAll" @change="selectall"/>
        </template>


       <template #cell(info)="items">             
            <feather-icon
              :icon="items.detailsShowing ? 'EyeIcon' : 'EyeOffIcon'"
              @click="items.toggleDetails"
            />
        </template>


        <template #cell(checkbox)="items">
           
            <b-form-checkbox v-model="selected" :value="items.item._id" class="custom-control-primary" />
         
        </template>

        <template #cell(site)="items">
           
            <span class="wordBreak" @click="items.toggleDetails">{{ items.item.site.site_name | capitalize}}</span>
         
        </template>

        <!-- Column: User -->
        <template #cell(title)="items">
           
            <span class="wordBreak"  @click="items.toggleDetails">{{ items.item.title | capitalize}}</span>
         
        </template>

        <!-- Column: Role -->
        <!-- <template #cell(site)="items">
           
            <span class="wordBreak">{{ items.item.site.site_name | capitalize}}</span>
         
        </template>

        <template #cell(location)="items">
           
            <span class="wordBreak" v-for="loc in items.item.locations" :key="loc._id">{{ loc.name | capitalize}}</span>
         
        </template> -->

        <!-- <template #cell(group)="items">

            <span class="wordBreak">{{items.item.group | groupArray}}</span>
         
        </template> -->

        <template #cell(from)="items">
           
            <!-- <span class="wordBreak">{{ items.item.from | date}}</span> -->
            <span  @click="items.toggleDetails">{{sitedateTime(items.item.from,siteData.pdf_date_format,'')}}</span>
         
        </template>

        <template #cell(to)="items">
           
            <!-- <span class="wordBreak">{{ items.item.to | date}}</span> -->
            <span  @click="items.toggleDetails">{{sitedateTime(items.item.to,siteData.pdf_date_format,'')}}</span>
         
        </template>

        <!-- <template #cell(frequency)="items">
           
            <span class="wordBreak">{{ items.item.frequency | capitalize}}</span>
         
        </template> -->

        
        <!-- <template #cell(status)="items">
           
            <b-badge
              pill
              :variant="variantColor(items.item.status)"
              class="text-capitalize"
            >
              {{ items.item.status}}
            </b-badge>
         
        </template> -->

        <template #cell(created_at)="items">
           
            <!-- <span>{{ items.item.created_at | dateTime}}</span> -->
            <span  @click="items.toggleDetails">{{sitedateTime(items.item.created_at,siteData.pdf_date_format,siteData.pdf_time_format)}}</span>
         
        </template>

        <template #cell(actions)="items">

          
          <!-- <b-dropdown
            v-if="checkPermission($route.name, 'Edit') || checkPermission($route.name, 'Change Status') || checkPermission($route.name, 'Delete')"
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          > -->

            <!-- <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template> -->

            
<!-- 
            <b-dropdown-item v-if="checkPermission($route.name, 'Edit')" :to="{ name: 'edit-periodic-task', params: { id: items.item._id } }">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item> -->

            <!-- <b-dropdown-item v-if="checkPermission($route.name, 'Change Status')" @click="statusChange(items.item)">
              <feather-icon :icon="items.item.status == 'active' ? 'UserMinusIcon' : 'UserCheckIcon'" />
              <span class="align-middle ml-50" v-if="items.item.status == 'active'">Inactive</span>
              <span class="align-middle ml-50" v-if="items.item.status == 'inactive'">Active</span>
            </b-dropdown-item> -->

            <!-- <b-dropdown-item v-if="checkPermission($route.name, 'Delete')" @click="deleteItem(items.item._id)">
              <feather-icon icon="Trash2Icon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item> -->

            

            
          <!-- </b-dropdown>  -->

           <b-link  v-if="checkPermission($route.name, 'Edit')" :to="{ name: 'edit-periodic-task', params: { id: items.item._id } }"
            v-b-tooltip.hover.v-warning
            title="Edit"
            variant="outline-warning"
          >
              <feather-icon icon="EditIcon" class="mediumSize"/>
              
          </b-link>
           <b-link  v-if="checkPermission($route.name, 'Delete')" @click="deleteItem(items.item._id)" 
            v-b-tooltip.hover.v-warning
            title="Delete"
            variant="outline-warning"
          >
              <feather-icon icon="Trash2Icon" class="mediumSize ml-1"/>
              
          </b-link>
        </template>

          <template #row-details="items">
            <div class="p-1 px-2 fbDetail mb-1">
                <b-row>

                  <b-col cols="12" xl="12" >
                      <table class="mt-2 mt-xl-0 w-100">
                          <tr class="mb-1">
                              <th class="pb-50" style="width: 10%">
                                <div class="d-flex align-items-center">
                          
                                  <div class="ml-1">
                                    <h6 class="mb-0 mediumFonts">
                                      Group
                                    </h6>
                                  <!--  <small>Monthly Sales</small> -->
                                  </div>
                                </div>
                              </th>
                              <td class="pb-50 mediumFonts" style="width: 10%;padding-top: 8px;">
                                   <span class="wordBreak">{{items.item.group | groupArray}}</span>
                              </td>
                               <th class="pb-50" style="width: 10%">
                                <div class="d-flex align-items-center">
                          
                                  <div class="ml-1">
                                    <h6 class="mb-0 mediumFonts">
                                      Frequency
                                    </h6>
                                  <!--  <small>Monthly Sales</small> -->
                                  </div>
                                </div>
                              </th>
                              <td class="pb-50 mediumFonts" style="width: 10%;padding-top: 8px;">
                                   <span class="wordBreak">{{ items.item.frequency | capitalize}}</span>
                              </td>
                          </tr>
                          <tr class="mb-1">
                            <th class="pb-50" style="width: 16%">
                              <b-button
                                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                  variant="outline-secondary"
                                  @click="items.toggleDetails"
                                  size="sm"
                                  class="ml-1"
                                >
                                  Hide Detail
                                </b-button>
                            </th>
                            <td class="pb-50 mediumFonts" style="width: 17%;padding-top: 8px;">
                                
                            </td>
                            <th class="pb-50" style="width: 16%">
                            </th>
                            <td class="pb-50 mediumFonts" style="width: 17%;padding-top: 8px;">
                                
                            </td>
                            <th class="pb-50" style="width: 16%">
                            </th>
                            <td class="pb-50 mediumFonts" style="width: 17%;padding-top: 8px;">
                                
                            </td>
                          </tr>
                      </table>
                  </b-col>

                </b-row>
            </div>

        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ from }} to {{ to }} of {{ totalRecords }}</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalRecords"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
              @input="filterTable"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,VBTooltip,
  BBadge, BDropdown, BDropdownItem, BPagination,BFormCheckbox,BCardBody,BBreadcrumb
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import { GET_API,POST_API } from "../../../store/actions.type"

export default {
  components: {
    BCardBody,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormCheckbox,
    vSelect,
    BBreadcrumb
  },
  directives: {
    'b-tooltip': VBTooltip
  },
  data() {
    return {
       tableColumns: [
            { key: 'checkbox', label:'',sortable: false , thStyle:  {width: '2%',fontSize:'10px'}},
            { key: 'info', label: 'INFO', sortable: false, thStyle: { width: '1%' } },
            { key: 'site', label: 'Project Site', sortable: false , thStyle:  {width: '13%',fontSize:'10px'}},
            { key: 'title', label: 'Task', sortable: true , thStyle:  {width: '15%',fontSize:'10px'}},
            /*
            { key: 'location', label: 'Location', sortable: true , thStyle:  {width: '15%',fontSize:'10px'}},
            */
            // { key: 'group', label: 'Group', sortable: true , thStyle:  {width: '12%',fontSize:'10px'}},
            { key: 'from', label: 'From Date', sortable: true , thStyle:  {width: '10%',fontSize:'10px'}},
            { key: 'to', label: 'To Date', sortable: true , thStyle:  {width: '10%',fontSize:'10px'}},
            // { key: 'frequency', label: 'Frequency', sortable: true , thStyle:  {width: '12%',fontSize:'10px'}},
            /*{ key: 'status', label: 'Status', sortable: true , thStyle:  {width: '8%',fontSize:'10px'}},*/
            { key: 'created_at', label: 'Added On', sortable: true , thStyle:  {width: '12%',fontSize:'10px'}},
            { key: 'actions', label: 'Action', sortable: false , thStyle:  {width: '12%',fontSize:'10px'}},
          ],
        
        items:[],
        isSortDirDesc: true,
        perPageOptions: [10, 20, 50, 100],
        perPage : 10,
        sortBy : 'id',
        webUrl: process.env.VUE_APP_SERVER_URL,
        totalRecords : 0,
        currentPage : 1,
        searchQuery:'',
        from:null,
        to:null,
        selectAll:false,
        selected:[],
        siteData:null,
        frequencyData:null,

        frequencies:[],
        sites:[],
        groupArray:[],
        group:[],
    }
  },
  methods : {
    dataList(){

      return this.$store.dispatch(POST_API, {
               data:{
                 page: this.currentPage,
                 keyword: this.searchQuery,
                 rowsPerPage:this.perPage,
                 sortBy:this.sortBy,
                 sortDirection:this.isSortDirDesc,
                 site:this.siteData ? this.siteData._id : null,

                 frequency:this.frequencyData ? this.frequencyData.name :null,

                 role:this.$store.getters.currentUser.role,
                 om_sites:this.$store.getters.currentUser.om_sites,
                 group:this.group,
               },
               api: '/api/periodic-task-list'
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    this.error_message = this.$store.getters.getErrors;
                } else {
                    this.items = this.$store.getters.getResults.data.docs;
                    this.totalRecords = this.$store.getters.getResults.data.total;
                    this.perPage = this.$store.getters.getResults.data.limit;
                    this.from = this.$store.getters.getResults.data.from
                    this.to = this.$store.getters.getResults.data.to
                    return this.items;
                }
            });

      
    },
    filterTable(){

      this.$refs.refUserListTable.refresh();
      this.selectAll = false;
      this.selected = [];
    },
    variantColor(status){
      if (status == 'active') {
        return 'success';
      }else{
        return 'primary';
      }
    },
    statusChange(item){
      if (item.status == 'active') {
          var msg = 'Are you sure want to inactivate this record?';
          var message='Task Inactivated Successfully.';
      } 
      else{
          var msg = 'Are you sure want to activate this record?';
          var message='Task Activated Successfully.';
      }

      Swal.fire({
                title: 'Please Confirm',
                text: msg,
                icon: 'warning',
                position: 'top-center',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
              })
            .then(result => {
              if (result.value) {
                  return this.$store.dispatch(POST_API, {
                    data:{
                          id: item._id,
                          status:item.status
                        },
                    api:"/api/change-periodic-task-status",
                      })
                      .then(() => {
                          if (this.$store.getters.containsErrors) {
                              this.error_message = this.$store.getters.getErrors;
                              this.showAlert();
                          } else {
                            
                            Swal.fire({
                              position: 'center',
                              icon: 'success',
                              title: message,
                              showConfirmButton: false,
                              timer: 1500
                            })
                            
                            this.$refs.refUserListTable.refresh();
                          }
                      });
              }
          })
          .catch(err => {
             
          })
    },

    deleteItem(id){
      var msg = 'Are you sure want to delete this record?';
      var message='Task Deleted Successfully.';

      Swal.fire({
                title: 'Please Confirm',
                text: msg,
                icon: 'warning',
                position: 'top-center',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
              })
            .then(result => {
              if (result.value) {
                  return this.$store.dispatch(POST_API, {
                    data:{
                          id: id,
                          status:'deleted'
                        },
                    api:"/api/change-periodic-task-status",
                      })
                      .then(() => {
                          if (this.$store.getters.containsErrors) {
                              this.error_message = this.$store.getters.getErrors;
                              this.showAlert();
                          } else {
                            
                            Swal.fire({
                              position: 'center',
                              icon: 'success',
                              title: message,
                              showConfirmButton: false,
                              timer: 1500
                            })
                            
                            this.$refs.refUserListTable.refresh();
                          }
                      });
              }
          })
          .catch(err => {
              
          })
    },
    selectall(e){

      this.selected = [];
      
      if (e) {
        var selected = [];

        this.items.forEach(function(item){
            selected.push(item._id);
        })

        this.selected = selected;

      }
    },
    changeMultipleStatus(status){

      if (this.selected.length > 0) {
       var msg = '';
       var msg2 = '';

       if (status == 'deleted') {
          msg = 'Are you sure you want to delete selected record?';
          msg2 = 'Records Deleted Successfully.';
       }if (status == 'active') {
          msg = 'Are you sure you want to Activate selected record?';
          msg2 = 'Records Activated Successfully.';
       }if (status == 'inactive') {

          msg = 'Are you sure you want to inactive selected record?';
          msg2 = 'Records Invated Successfully.';
       }

       
       Swal.fire({
                title: 'Please Confirm',
                text: msg,
                icon: 'warning',
                position: 'top-center',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
              })
            .then(result => {
              if (result.value) {
                  return this.$store.dispatch(POST_API, {
                    data:{
                          id: this.selected,
                          status:status
                        },
                    api:"/api/change-multiple-periodic-status",
                      })
                      .then(() => {
                          if (this.$store.getters.containsErrors) {
                              this.error_message = this.$store.getters.getErrors;
                              this.showAlert();
                          } else {
                            
                            Swal.fire({
                              position: 'center',
                              icon: 'success',
                              title: msg2,
                              showConfirmButton: false,
                              timer: 1500
                            })
                            
                            this.selected = [];
                            this.selectAll = false;
                  
                            this.$refs.refUserListTable.refresh();
                          }
                      });
              }
          })
          .catch(err => {
              // An error occurred
          })   
  
      }else{
          Swal.fire({
            position: 'center',
            icon: 'warning',
            title: 'Please select tasks.',
            showConfirmButton: false,
            timer: 1500
          })
      }
    },
    allSites(){
      return this.$store.dispatch(POST_API, {
         data:{
              role:this.$store.getters.currentUser.role,
              om_sites:this.$store.getters.currentUser.om_sites,
         },
         api: '/api/all-sites'
      })
      .then(() => {
          if (this.$store.getters.containsErrors) {
              this.error_message = this.$store.getters.getErrors;
          } else {
              this.sites = this.$store.getters.getResults.data;
              /*this.siteData = this.sites.length > 0 ? this.sites[0] : null;
              this.filterTable();*/

              // if (this.sites.length == 1 ) {
              //     this.siteData = this.sites[0];
              //     this.getSiteGroup();
              //     this.filterTable();
              // }

              var obj = {
                _id:'all-site',
                site_name:'All Project Sites',
                pdf_date_format: 'DD MMM YYYY',
                pdf_time_format: 'HH:mm'
              }
              this.sites.unshift(obj);

              this.siteData = this.defaultSite(this.sites);
              this.getSiteGroup();
              this.filterTable();

              return this.sites;
          }
      });
    },

    allFrequencies(){
      return this.$store.dispatch(POST_API, {
           data:{
             
           },
           api: '/api/all-periodic-frequencies'
        })
        .then(() => {
            if (this.$store.getters.containsErrors) {
                this.error_message = this.$store.getters.getErrors;
                this.showDismissibleAlert = true;
                window.scrollTo(0,0);
            } else {
                this.showDismissibleAlert = false;
                var data  = this.$store.getters.getResults.data;
                
                this.frequencies = data;
                
                return this.frequencies;
            }
        });
    },
    siteChange(){

      this.groupArray = [];
      this.group = [];

      if (this.siteData != null && this.siteData._id != 'all-site') {
        this.getSiteGroup();
      }

      this.filterTable()
    },
    getSiteGroup(){

      return this.$store.dispatch(POST_API, {
           data:{
             site:this.siteData._id,
           },
           api: '/api/task-group-suggestions'
        })
        .then(() => {
            if (this.$store.getters.containsErrors) {
                this.error_message = this.$store.getters.getErrors;
                this.showDismissibleAlert = true;
                //window.scrollTo(0,0);
            } else {
                this.showDismissibleAlert = false;
                var data  = this.$store.getters.getResults.data;
                
                this.groupArray = data;
                return this.groupArray;
            }
        });
    },
    breadCrumb(){
      var item = [{
        to:{name:'client-dashboard'},
        text: 'Dashboard',
      },{
        to:null,
        text: 'Schedule Work'
      },{
        to:null,
        text: 'Schedule Task',
        active:true
      }];
      return item;
    }
  },
  mounted(){
    this.allSites();
    this.allFrequencies();
  }
  
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
